import numeral from "numeral";

// ----------------------------------------------------------------------

export function fCurrency(number: string | number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}

export function fPercent(number: number) {
  return numeral(number / 100).format("0.0%");
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return numeral(number).format("0.00a").replace(".00", "");
}

export function fData(number: string | number) {
  return numeral(number).format("0.0 b");
}

export function formatCurrency(number: string | number, format: string) {
  if (number == null || isNaN(Number(number))) return number?.toString() ?? "";
  if (format === "0,0.00") {
    const num = Number(number);
    const decimals = 4;
    const truncated = Math.floor(num * 10 ** decimals) / 10 ** decimals;
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: decimals,
    }).format(truncated);
  }
  return numeral(number).format(format);
}

export function formatAmountWithCurrency(amount: number, currency: string) {
  const localeMap: Record<typeof currency, string> = {
    USD: "en-US",
    EUR: "de-DE", // You could also use "en-IE" or "fr-FR" depending on your users
    GBP: "en-GB",
  };

  const locale = localeMap[currency] || "en-US";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}

export const formatNumber = (num) =>
  num >= 1 && num <= 9 ? `0${num}` : num.toString();
export function formatIBAN(iban) {
  // Remove any non-alphanumeric characters
  const cleanIBAN = iban?.replace(/\s+/g, "");

  // Insert a space after every 4 characters
  return cleanIBAN?.match(/.{1,4}/g).join(" ");
}

export function formatIBANMasked(iban: string) {
  const cleanIBAN = iban?.replace(/\s+/g, "");
  const visibleDigits = cleanIBAN?.slice(-4);
  const maskedLength = cleanIBAN?.length - 4;
  const masked = "*".repeat(maskedLength) + visibleDigits;
  return masked?.match(/.{1,4}/g)?.join(" ");
}

export const parseNumber = (v: any) => {
  if (v === null || v === undefined || v === "") return 0;
  const cleaned = String(v).replace(/,/g, "").trim();
  const n = parseFloat(cleaned);
  return Number.isNaN(n) ? 0 : n;
};
